import ClientsSection from '../ones/ClientsSection';
import InquiryCta from '../ones/InquiryCta';
import Footer from '../ones/Footer';

export default function ProjectsLanding() {
  return <><header className="HospiumPageHero"><div className="container"><span className="HospiumKicker">Our clients</span><h1>Healthcare providers building with Hospium</h1><p>We work closely with providers to shape practical tools around real operational needs.</p></div></header><ClientsSection /><InquiryCta compact /><Footer /></>;
}
